import { useUserProfile } from '../../hooks';
import { WbAvatar, WbAvatarProps } from './WbAvatar';

type WbUserAvatarProps = Omit<WbAvatarProps, 'displayName' | 'picture'>;

export const WbUserAvatar = (props: WbUserAvatarProps) => {
  const { displayName, profile } = useUserProfile();

  return (
    <WbAvatar
      classes={props.classes}
      displayName={displayName}
      picture={profile.picture}
    />
  );
};
